import React from "react";
import { Spin } from "antd";

const UILoading = () => {
  return <Spin />;
};

export default UILoading;
